import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useUser } from './UserContext';

const LogContext = createContext();

export function LogProvider({ children }) {
  const { user } = useUser();                   // ← pull real user
  const [logs, setLogs] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('admin_logs')) || [];
    } catch {
      return [];
    }
  });
  const nextId = useRef(logs.length + 1);

  // persist to localStorage
  useEffect(() => {
    localStorage.setItem('admin_logs', JSON.stringify(logs));
  }, [logs]);

  function logActivity(description) {
    const entry = {
      id:        nextId.current++,
      description,
      user:      user.user_name || 'Unknown',
      timestamp: new Date().toISOString().slice(0, 19).replace('T', ' ')
    };
    setLogs(prev => [entry, ...prev]);
  }

  function clearLogs() {
    nextId.current = 1;
    setLogs([]);
  }

  return (
    <LogContext.Provider value={{ logs, logActivity, clearLogs }}>
      {children}
    </LogContext.Provider>
  );
}

export function useLogs() {
  const ctx = useContext(LogContext);
  if (!ctx) throw new Error('useLogs must be used inside a <LogProvider>');
  return ctx;
}
